import { FileTextOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/review-rating-card.module.scss';
import SectionCard from '../../common/sectionCard/SectionCard';
import ReviewDetailRow from './ReviewDetailRow';
import { Rate, Divider } from 'antd';

function ReviewBasicInfoCard({ review }) {
    return (
        <SectionCard icon={<FileTextOutlined />} title="Rating & Feedback">
            <ReviewDetailRow label="Client Name" value={review.name} />
            <div className={styles.ratingBlock}>
                <Text as="span" size="xs" className={styles.ratingLabel}>
                    RATING
                </Text>
                <div className={styles.ratingDisplay}>
                    <Rate disabled defaultValue={review.rating} count={10} style={{ fontSize: '18px' }} />
                    <Text as="span" size="lg" className={styles.ratingValue}>
                        {review.rating}/10
                    </Text>
                </div>
            </div>

            <Divider style={{ margin: '16px 0' }} />

            <div className={styles.commentsBlock}>
                <Text as="span" size="xs" className={styles.commentsLabel}>
                    COMMENTS
                </Text>
                <div className={styles.commentsContent}>
                    {review.comments ? (
                        <Text as="span" size="sm">
                            {review.comments}
                        </Text>
                    ) : (
                        <Text as="span" size="sm" className={styles.commentsEmpty}>
                            No comments provided
                        </Text>
                    )}
                </div>
            </div>
            <ReviewDetailRow
                label="Date"
                value={moment(review.timestamp_ms).format('MMM DD, YYYY HH:mm')}
            />
        </SectionCard>
    );
}

export default ReviewBasicInfoCard;
